export const MAX_LINK_LENGTH = 2000;
export const LINK_LIST_COLORS = ["#2F6BFD", "#0E379A", "#FFFFFF"];
export const TEXTALIGN = ["left", "center", "right"];
export const LINESPACING = ["0.8", "0.9", "1", "1.1", "1.2", "1.3", "1.5"];
export const FONTS = [
  "Roboto",
  "Arial",
  "Verdana",
  "Helvetica",
  "Tahoma",
  "Times New Roman",
  "Georgia",
  "Garamond",
  "Courier New",
  "Comic Sans MS",
];
export const TEXT_SIZES = [
  8, 10, 12, 14, 16, 18, 20, 22, 24, 28, 30, 32, 34, 36, 40, 42, 44, 46, 48, 50,
];